import { faCartShopping, faMoneyCheck, faTruck, faTruckFieldUn } from "@fortawesome/free-solid-svg-icons"
import { useLocales } from "react-localized"
import { SectionMenu, SectionMenuItem } from "../lib"


const ProcurementSectionMenu: React.FC = () => {
  const {gettext} = useLocales()
  return (
    <SectionMenu icon={faCartShopping} title={gettext("Procurement")}>
      <SectionMenuItem
        icon={faMoneyCheck}
        title={gettext("Purchase orders")}
        path="/procurement/orders"
      />
      <SectionMenuItem
        icon={faTruckFieldUn}
        title={gettext("Suppliers")}
        path="/procurement/suppliers"
      />
    </SectionMenu>   
  )
}

export default ProcurementSectionMenu